module.exports = __webpack_public_path__ + "static/assets/7574ecb62368e7df047d884160264682.png";